import { render, staticRenderFns } from "./CustomEditor.vue?vue&type=template&id=0560e0d5&scoped=true&"
import script from "./CustomEditor.vue?vue&type=script&lang=js&"
export * from "./CustomEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustomEditor.vue?vue&type=style&index=0&id=0560e0d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560e0d5",
  null
  
)

export default component.exports